/* import __COLOCATED_TEMPLATE__ from './appointments-subs-plans-page.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { DEFAULT_SELECTED_PLAN } from '@square/appointments-feature-upsell/services/appointments-feature-info';
let AppointmentsSubsPlansPageComponent = (_class = class AppointmentsSubsPlansPageComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isComparePlansModalOpen", _descriptor, this);
    _initializerDefineProperty(this, "selectedPlan", _descriptor2, this);
    _initializerDefineProperty(this, "appointmentsSubscription", _descriptor3, this);
    _initializerDefineProperty(this, "dataApi", _descriptor4, this);
  }
  get title() {
    return this.args.title ?? '';
  }
  get subtitle() {
    return this.args.subtitle ?? '';
  }
  get subscriptionPlans() {
    return this.args.subscriptionPlans ?? [];
  }
  get showComparePlans() {
    return this.args.showComparePlans ?? false;
  }
  get canManageSubscriptions() {
    return this.args.canManageSubscriptions ?? false;
  }
  get pageNameForCDPTracking() {
    return this.args.pageNameForCDPTracking ?? '';
  }
  get hasTitle() {
    return Boolean(this.title);
  }
  get hasSubtitle() {
    return Boolean(this.subtitle);
  }
  get defaultSelectedPlan() {
    return DEFAULT_SELECTED_PLAN;
  }
  compareLinkClicked() {
    if (this.showComparePlans) {
      this.isComparePlansModalOpen = true;
    }
    this.args.trackComparePlansClicked?.();
    this.dataApi.track('Click Page', {
      platform: 'web',
      page_name: this.pageNameForCDPTracking,
      item_clicked: 'compare',
      subscription_state: this.appointmentsSubscription.status,
      plan_token: this.appointmentsSubscription.planToken
    });
  }
  onDismissModal() {
    this.isComparePlansModalOpen = false;
    this.dataApi.track('Click Page', {
      platform: 'web',
      page_name: this.pageNameForCDPTracking,
      item_clicked: 'dismiss compare plans',
      subscription_state: this.appointmentsSubscription.status,
      plan_token: this.appointmentsSubscription.planToken
    });
  }
  onTabChange(e) {
    // Both the selected and the previously selected tab will emit marketTabSelectedChanged, so we
    // only trigger the tab change method for the selected tab (which has value=true)
    if (e.detail?.value) {
      // Looks at the <market-tab>'s id attribute
      const selectedTabId = e.detail.tabId;
      const selectedPlan = this.subscriptionPlans.find(plan => plan.token === selectedTabId);
      if (selectedPlan) {
        this.selectedPlan = selectedPlan;
      }
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isComparePlansModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedPlan", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "appointmentsSubscription", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "compareLinkClicked", [action], Object.getOwnPropertyDescriptor(_class.prototype, "compareLinkClicked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDismissModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDismissModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onTabChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onTabChange"), _class.prototype), _class);
export { AppointmentsSubsPlansPageComponent as default };